import { Box } from '@mui/material';
import styled from 'styled-components';

interface StyledTextContainerProps {
  headerColor: string;
  headerSize: number;
  headerWeight: number | string;
  textColor: string;
  textSize: number;
  textWeight: number | string;
}

export const StyledFailedContainer = styled(Box)`
  font-family: var(--font-family);
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;

  .checkout-failed__close-icon {
    width: 100%;
    display: flex;
    justify-content: end;
  }

  .checkout-failed__payment-reference {
    margin-top: 20px;
  }
`;

export const StyledTextContainer = styled.div<StyledTextContainerProps>`
  font-family: var(--font-family);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  .checkout-completion__text-container {
    &__header {
      margin: unset;
      color: ${(props: any) => props.headerColor};
      font-size: ${(props: any) => props.headerSize + 'px'};
      font-weight: ${(props: any) => props.headerWeight};
    }

    &__sub-header {
      color: ${(props: any) => props.textColor};
      font-size: ${(props: any) => props.textSize + 'px'};
      font-weight: ${(props: any) => props.textWeight};
    }
  }
`;

interface StyledEnrichedMsgProps {
  textColor: string;
  textSize: number;
  textWeight: number | string;
}

export const StyledEnrichedMsg = styled.div<StyledEnrichedMsgProps>`
  font-size: ${(props: any) => props.textSize + 'px'};
  font-weight: ${(props: any) => props.textWeight};
  color: ${(props: any) => props.textColor};

  a {
    color: ${(props: any) => props.textColor};
    text-decoration-color: ${(props: any) => props.textColor};
  }
`;
